import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import './styles.css';

import {SETUP_GOCARDLESS_TABS} from 'ducks/tenancy';

const Navigation: React.SFC<any> = ({selectedTab, selectTab}) => (
  <div className="Navigation colab-elements-row">
    {_.map(SETUP_GOCARDLESS_TABS, (value, key) => {
      const selected = selectedTab === value;

      return (
        <div
          key={key}
          className={classNames('navigationTab colab-clickable', {selected})}
          onClick={() => selectTab(value)}>
          {value}
        </div>
      );
    })}
  </div>
);

export default Navigation;
